import React from "react";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { hasVisibleContent } from "../../../functional/showBladeHeader";
import { BladeContent } from "../../../components/BladeContent";
import { Backdrop, BackdropBackground, BackdropForeground } from "../../../components/Backdrop";
import { Media } from "../../../components/Media";
import { RichText } from "../../../components/RichText";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle } from "../../../components/BladeHeader";
import { CTA } from "../../../components/CTA";
import { z } from "zod";
import { MastheadBladeSchema } from "../../../schemas/blades/Masthead";
export const CenterPromoMastheadContractSchema = MastheadBladeSchema.extend({
    type: z.literal("centerPromoMasthead"),
});
const _CenterPromoMasthead = ({ backdrop, header, className, ...bladeProps }) => {
    const headerContent = hasVisibleContent(header);
    const hasLinks = header?.links && header?.links.length > 0;
    const links = (hasLinks && header?.links) || [];
    return (React.createElement(Blade, { className: className, "data-testid": "CenterPromoMasthead", ...bladeProps },
        backdrop && (React.createElement(Backdrop, null,
            React.createElement(BackdropBackground, null, backdrop.background && (React.createElement(Media, { "data-testid": "backdrop-embed-video", optimized: true, autoPlay: true, media: backdrop.background }))),
            React.createElement(BackdropForeground, null, backdrop.foreground && (React.createElement(Media, { "data-testid": "backdrop-foreground-image", media: backdrop.foreground, role: "presentation" }))))),
        React.createElement(BladeContent, { width: "medium", className: [backdrop && "has-backdrop", links.length > 0 && "has-links"].filter(Boolean).join(" ") },
            headerContent && (React.createElement(BladeHeader, null,
                header?.supertitle && (React.createElement(BladeHeaderSupertitle, { "data-testid": "supertitle" }, header.supertitle)),
                header?.title && (React.createElement(BladeHeaderTitle, { "data-testid": "title" },
                    React.createElement("h1", null, header.title))),
                header?.description ? (React.createElement(BladeHeaderBody, { "data-testid": "body" },
                    React.createElement(RichText, { ...header.description }))) : null)),
            hasLinks ? (React.createElement("div", { className: `ctaContainer ${!headerContent && "solo-cta"}`, "data-testid": "links" }, links.map((link, index) => (React.createElement(CTA, { variant: index === 0 ? "primary" : "secondary", ...link, key: index, "data-testid": `cta-${index}` }))))) : null)));
};
export const CenterPromoMasthead = styled(_CenterPromoMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=CenterPromoMasthead.js.map